import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { getField, formatNumber, formatQuotaionNumber, caluculateTax  } from 'src/common/helper';

type PrintReceiptProps = {
  detailData: any;
  patientInfo: any;
  receiptInfo: any;
};

const constraints = {
  tenantName: '一般社団法人日本美容医療研究機構',
  subTenantName: 'リゾナスフェイスクリニック東京',
  address: '〒105-0004　 東京都港区新橋3丁目3-13 Tsao Hibiya4F・5F',
  registrationNumber: 'T7-8102-9520-6964',
};

const rowStyle = {
  height: '8mm',
  border: 'none',
  borderBottom: '1px solid #1976d2',
  borderTop: '1px solid #1976d2',
  padding: '0'
}

const PrintReceipt: React.FC<PrintReceiptProps> = (props) => {
  return (
    <Box
      sx={{
        width: '100%',
        fontFamily: 'Arial, sans-serif',
        '@media print': {
          padding: '20mm',
        }
      }}
    >
      <Box sx={{ 
        border: '1px solid #CACACA'
      }}>
        <Typography
          sx={{
            textAlign: 'center',
            fontWeight: 'bold',
            backgroundColor: '#2F75B5',
            color: 'white',
            fontSize: '22px',
            padding: '16px',
            letterSpacing: '8mm'
          }}
        >
          領収書
        </Typography>

        <Box sx={{ 
          padding: '16px',
          backgroundColor: '#FFFFFF',
        }}>
          <Box display={'flex'} justifyContent={'space-between'} sx={{ mb: '16px' }}>
            <Typography sx={{ fontSize: '12px', textAlign: 'center', borderBottom: '2px solid #2F75B5', width: '80mm' }}>
              {props.receiptInfo?.patientName}　様
            </Typography>
            <Typography sx={{ fontSize: '9px' }}>
              {`No. ${formatQuotaionNumber(getField(props.detailData, 'id', '0'))}`}
            </Typography>
          </Box>

          <TableContainer sx={{ maxWidth: '100mm', margin: 'auto' }}>
            <Table>
              <TableBody>
                <TableRow sx={{ ...rowStyle, backgroundColor: '#DDEBF7', borderWidth: '2px' }}>
                  <TableCell align="right" sx={{ ...rowStyle, width: '20%' }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>
                      金額
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={{ ...rowStyle }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>
                      ¥ {formatNumber(props.receiptInfo?.totalAmount)}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ ...rowStyle }}>
                  <TableCell align="right" sx={{ ...rowStyle, width: '20%' }}>
                    <Typography sx={{ fontSize: '10px' }}>
                      但し
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={{ ...rowStyle }}>
                    <Typography sx={{ fontSize: '10px' }}>
                      {props.receiptInfo?.note}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ ...rowStyle }}>
                  <TableCell align="right" sx={{ ...rowStyle, width: '20%' }}>
                    <Typography sx={{ fontSize: '10px' }}>
                      領収日
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={{ ...rowStyle }}>
                    <Typography sx={{ fontSize: '10px' }}>
                      {props.receiptInfo?.receiptDate}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Typography fontSize='9px' sx={{ textAlign: 'center', marginBottom: '8mm' }}>
            上記正に領収しました
          </Typography>

          <Box display={'flex'} justifyContent={'space-between'}>
            <Box sx={{ width: '50%' }} gap='4mm'>
              <Typography fontSize='9px'>
                内訳
              </Typography>

              <TableContainer sx={{ width: '75%' }}>
                <Table>
                  <TableBody>
                    <TableRow sx={{ ...rowStyle, borderBottom: 'none' }}>
                      <TableCell align="left" sx={{ ...rowStyle, borderBottom: 'none', width: '20%' }}>
                        <Typography sx={{ fontSize: '9px' }}>
                          10%
                        </Typography>
                      </TableCell>
                      <TableCell align="left" sx={{ ...rowStyle, borderBottom: 'none' }}>
                        <Typography sx={{ fontSize: '9px' }}>
                          税込金額
                        </Typography>
                      </TableCell>
                      <TableCell align="right" sx={{ ...rowStyle, borderBottom: 'none' }}>
                        <Typography sx={{ fontSize: '9px' }}>
                        {formatNumber(props.receiptInfo?.totalAmountTax10)}円
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ ...rowStyle, borderTop: 'none' }}>
                      <TableCell align="left" sx={{ ...rowStyle, borderTop: 'none', width: '20%' }}></TableCell>
                      <TableCell align="left" sx={{ ...rowStyle, borderTop: 'none' }}>
                        <Typography sx={{ fontSize: '9px' }}>
                          消費税等
                        </Typography>
                      </TableCell>
                      <TableCell align="right" sx={{ ...rowStyle, borderTop: 'none' }}>
                        <Typography sx={{ fontSize: '9px' }}>
                          {formatNumber(caluculateTax(props.receiptInfo?.totalAmountTax10, 0.1))}円
                        </Typography>
                      </TableCell>
                    </TableRow>

                    <TableRow sx={{ ...rowStyle, borderBottom: 'none' }}>
                      <TableCell align="left" sx={{ ...rowStyle, borderBottom: 'none', width: '20%' }}>
                        <Typography sx={{ fontSize: '9px' }}>
                          8%
                        </Typography>
                      </TableCell>
                      <TableCell align="left" sx={{ ...rowStyle, borderBottom: 'none' }}>
                        <Typography sx={{ fontSize: '9px' }}>
                          税込金額
                        </Typography>
                      </TableCell>
                      <TableCell align="right" sx={{ ...rowStyle, borderBottom: 'none' }}>
                        <Typography sx={{ fontSize: '9px' }}>
                          {formatNumber(props.receiptInfo?.totalAmountTax8)}円
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ ...rowStyle, borderTop: 'none' }}>
                      <TableCell align="left" sx={{ ...rowStyle, borderTop: 'none', width: '20%' }}></TableCell>
                      <TableCell align="left" sx={{ ...rowStyle, borderTop: 'none' }}>
                        <Typography sx={{ fontSize: '9px' }}>
                          消費税等
                        </Typography>
                      </TableCell>
                      <TableCell align="right" sx={{ ...rowStyle, borderTop: 'none' }}>
                        <Typography sx={{ fontSize: '9px' }}>
                          {formatNumber(caluculateTax(props.receiptInfo?.totalAmountTax8, 0.08))}円
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Box sx={{ width: '50%' }} gap='4mm'>
              <Typography sx={{ fontWeight: 'bold', fontSize: '11px' }}>
                {constraints.tenantName}
              </Typography>
              {constraints.subTenantName && (
                <Typography sx={{ fontWeight: 'bold', fontSize: '9px' }}>
                  {constraints.subTenantName}
                </Typography>
              )}
              <Typography sx={{ fontSize: '9px' }}>
                {constraints.address}
              </Typography>
              {constraints.registrationNumber && (
                <Typography sx={{ fontSize: '9px' }}>
                  登録番号：{constraints.registrationNumber}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>

      </Box>
    </Box>
  );
}

export default PrintReceipt;
